export default __webpack_public_path__ + "static/megame-3b24145c1ecae6bdce5a40fee5b546f7.png";